import React from 'react';

const DataGrid = () => {
    return <div>DataGrid</div>;
};

export default DataGrid;
